import { PillProps } from "@ingka/pill";
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";

const useFilterUsers = (
	usersTypes: PillProps[],
	setToggleUserTypeBtnIndex: Dispatch<SetStateAction<number | undefined>>
) => {
	const [pills, setPills] = useState<PillProps[]>([]);

	useEffect(() => {
		setPills(usersTypes);
	}, [usersTypes]);

	const handlePills = useCallback(
		(selectedPills: number[]) => {
			setToggleUserTypeBtnIndex(selectedPills[0]);
			setPills((prevPills) =>
				prevPills.map((pill, index) => ({
					...pill,
					selected: selectedPills.includes(index),
				}))
			);
		},
		[setToggleUserTypeBtnIndex]
	);

	return {
		pills,
		handlePills,
	};
};

export default useFilterUsers;
